import ResultsTableRow from './ResultsTableRow';

export default ResultsTableRow;
